import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createAyudaProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {
    const ayudaAdminProvider: ISearchProvider = {
        key: "ayuda-admin",
        label: "Ayuda: Administración",
        subLabel: "Documentación de administración de KidiAdmin",
        action: ctx.navigateModule("ayuda/admin"),
        search: (): ISearchResult[] => ([]),
    }

    const ayudaMaestraProvider: ISearchProvider = {
        key: "ayuda-maestra",
        label: "Ayuda: Maestr@s",
        subLabel: "Documentación de KidiTeachers para maestr@s",
        action: ctx.navigateModule("ayuda/maestros"),
        search: (): ISearchResult[] => ([]),
    };

    const ayudaPapasProvider: ISearchProvider = {
        key: "ayuda-papas",
        label: "Ayuda: Papás",
        subLabel: "Documentación de KidiPapás",
        action: ctx.navigateModule("ayuda/papas"),
        search: (): ISearchResult[] => ([]),
    };

    const ayudaAlumnosProvider: ISearchProvider = {
        key: "ayuda-alumnos",
        label: "Ayuda: Alumnos",
        subLabel: "Documentación referente a los alumnos en el sistema",
        action: ctx.navigateModule("ayuda/alumnos"),
        search: (): ISearchResult[] => ([]),
    };

    return [
        ayudaAdminProvider,
        ayudaMaestraProvider,
        ayudaPapasProvider,
        ayudaAlumnosProvider,
    ];
}